import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModelService {

  constructor(private datePipe: DatePipe,
              private router: Router) {
  }

  getModelLabel(model: any, identifier: string) {
    switch (identifier) {
      case 'objects':
      case 'teams':
      case 'device-types':
      case 'equipment':
      case 'materials':
      case 'assignment-types':
      case 'devices':
      case 'trainings':
      case 'qualifications':
      case 'maintenance-types':
      case 'storages':
      case 'additional-options':
        return model.name;
      case 'device-allocations':
        return model.tableable?.employee?.person?.firstName
          ? model.tableable?.employee?.person?.firstName +
              ' ' +
              model.tableable?.employee?.person?.lastName
          : model.tableable.name;
      case 'employees':
        return model.person.firstName + ' ' + model.person.lastName;
      case 'deficiencies':
      case 'assignment-extensions':
      case 'reviews':
        return model.title;
      case 'assignments':
      case 'on-call-assignments':
      case 'offers':
        return model.assignmentDetail.title;
      case 'executions':
        return model.calendarEntry.start
          ? (this.datePipe.transform(
              model.calendarEntry.start,
              environment.displayDateFormat,
            ) ?? '')
          : model.id;
      case 'documents':
        return model.fileName;
      case 'customers':
        return model.company;
      case 'used-materials':
        return model.material.name;
      case 'suppliers':
        return model.company;
      case 'sick-leaves':
        return (
          (this.datePipe.transform(
            model.startDate ?? model.calendarEntry.start,
            environment.displayDateFormat,
          ) ?? '') +
          (this.router.url.includes('employees')
            ? ''
            : ' - ' +
              model.user.employee.person.firstName +
              ' ' +
              model.user.employee.person.lastName)
        );
      case 'holidays':
        return (
          (this.datePipe.transform(
            model.calendarEntry.start,
            environment.displayDateFormat,
          ) ?? '') +
          ' - ' +
          (this.datePipe.transform(
            model.calendarEntry.end,
            environment.displayDateFormat,
          ) ?? '?') +
          (this.router.url.includes('employees')
            ? ''
            : ' - ' +
              model.user.employee.person.firstName +
              ' ' +
              model.user.employee.person.lastName)
        );
      case 'execution-teams':
        return (
          model.user.employee.person.firstName +
          ' ' +
          model.user.employee.person.lastName
        );
      case 'maintenances':
        return model.maintenanceType.name;
      case 'object-reviews':
        return this.datePipe.transform(
          model.date ?? model.plannedDate ?? model.calendarEntry?.start,
          environment.displayDateFormat,
        );
      case 'assignment-review-ratings':
        return model.review.title;
      case 'user-trainings':
        return model.training.name;
      case 'execution-additional-option-values':
        return model.additionalOption.name;
    }

    return '';
  }
}
